<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="epub-b">ACKNOWLEDGMENTS</span></span></p>
<p class="tni">There are several debts which I can’t pay back but want to mention anyway. Kate Hovde was a part of this story in ways only she and I know. Michelle Burch and Tim DiLaura provided friendship throughout my time in Togo, and in Boston, David Miller shared an obsession with Africa and literature during difficult months of the writing. Nancy Packer and Gail Perez read the entire manuscript; they were as acute and supportive as any critics I could ask for. Becky Saletan of Vintage Books and Bob Lescher, my agent, took a chance on a book by a fledgling writer about an obscure place.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?79a915a6